'use client';

import { Footer } from '@/components/footer';
import { Grid } from '@/components/grid';
import { Hero } from '@/components/hero';
import { RecentProjects } from '@/components/recent-projects';
import { Skills } from '@/components/skills';
import { FloatingNav } from '@/components/ui/floating-nav';
import { HeroHighlight } from '@/components/ui/hero-highlight';
import { TracingBeam } from '@/components/ui/tracing-beam';
import { WorkExperience } from '@/components/work-experience';

import { navItems, projects, skills, workExperience } from '@/data';

export default function Home() {
  return (
    <main className="bg-black-100 relative flex justify-center items-center flex-col mx-auto overflow-hidden sm:px-10 px-5 pb-10">
      <TracingBeam className="max-w-7xl w-full" contentContainerClassName="flex flex-col gap-y-24">
        <FloatingNav navItems={navItems} />
        <HeroHighlight>
          <Hero />
        </HeroHighlight>
        <Grid />
        <RecentProjects data={projects} />
        <WorkExperience data={workExperience} />
        <Skills data={skills} />
        <Footer />
      </TracingBeam>
    </main>
  );
}
